import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';

/**
 * Type representing the navigate back function
 */
export type NavigateBack = ReturnType<typeof useNavigateBack>;

export const useNavigateBack = ({ logger }: LoggingContext) => {
  const navigate = useNavigate();

  const navigateBack = useCallback(() => {
    logger?.debug('Navigating back to the previous page');

    navigate(-1);
  }, [navigate]);

  return navigateBack;
};
